import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class DashboardService {

  env = environment;
  constructor(private readonly http: HttpClient) { }

  creditHistory(params: any) {
    return this.http.post(this.env.webApiUrl + 'api/Dashboard/CreditHistory', params);
  }

  creditHistoryMonths() {
    return this.http.post(this.env.webApiUrl + 'api/Dashboard/CreditHistoryMonths', null);
  }

  creditHealthInfo(params: any) {
    return this.http.post(this.env.webApiUrl + 'api/Dashboard/CreditHealthInfo', params);
  }
  getHistoricCreditScoreByIdNumber() {
    return this.http.post(this.env.webApiUrl + 'api/Dashboard/GetHistoricCreditScoreByIdNumber', null);
  }

  validateSplAndHlUser() {
    return this.http.post(this.env.webApiUrl + 'api/Dashboard/ValidateSplAndHlUser', null);
  }

  getUserIntermediaryAndLeaderBanner()
  {
    return this.http.post(this.env.webApiUrl + 'api/Dashboard/GetUserIntermediaryAndLeaderBanner', null);
  }
 

  loadCreditHistoryCombinedCalls(params: any) {
    return this.http.post(this.env.webApiUrl + 'api/Dashboard/LoadCreditHistoryCalls', params);
  }
  processUserForDcQuote(params: any) {
    return this.http.post(this.env.webApiUrl + 'api/Dashboard/CallDcQuoteOnLogin', params);
  }

}
